{
  "branding": {
    "frontdesk-attribution": "FrontDesk+ tarafından desteklenmektedir",
    "practice-logo": "{{name}} logosu"
  },
  "validation": {
    "required": "Bu alan gereklidir",
    "invalid-url": "Lütfen geçerli bir URL girin",
    "pin-too-short": "PIN en az 4 karakter olmalıdır",
    "pin-default-rejected": "Standart PIN 0000'a izin verilmez. Lütfen kendi PIN'inizi atayın.",
    "invalid-kim-address": "Please enter a valid KIM address (e.g. praxis@musterpraxis.kim.telematik)."
  },
  "common": {
    "back": "Geri",
    "next": "İleri",
    "cancel": "İptal",
    "confirm": "Onayla",
    "done": "Tamam",
    "retry": "Tekrar dene",
    "clear": "Temizle",
    "close": "Kapat",
    "verifying": "Doğrulanıyor...",
    "select": "Seç",
    "minutes": "dakika",
    "clock": "",
    "gender": {
      "M": "Erkek",
      "W": "Kadın",
      "D": "Diğer",
      "U": "Bilinmiyor"
    },
    "insurance": {
      "GKV": "Yasal",
      "PKV": "Özel",
      "SELFPAY": "Özel ödeme"
    },
    "scroll-up": "Yukarı kaydır",
    "scroll-down": "Aşağı kaydır"
  },
  "settings": {
    "device-reset": {
      "title": "Cihazı sıfırla",
      "description": "Bu cihazın muayenehane bağlantısını, ayarlarını ve PIN kodunu silin.",
      "confirmation": "Bu cihazın yeniden kurulması gerekir. SOL yapılandırması ve inSuite içindeki hasta verileri değişmez.",
      "cancel": "İptal",
      "confirm": "Şimdi sıfırla"
    },
    "title": "Ayarlar",
    "save": "Kaydet",
    "save-success": "Ayarlar kaydedildi",
    "save-error": "Kaydetme başarısız",
    "load-error": "Ayarlar yüklenemedi",
    "pin": {
      "title": "PIN Gerekli",
      "description": "Ayarlara erişmek için lütfen PIN'inizi girin.",
      "error": "Yanlış PIN. Lütfen tekrar deneyin.",
      "backspace": "Son rakamı sil"
    },
    "connection": {
      "title": "Bağlantı",
      "description": "Doc-Cirrus Bridge sunucusu için bağlantı ayarları",
      "bridge-url": "Bridge URL",
      "device-name": "Cihaz Adı",
      "device-name-placeholder": "ör. Resepsiyon, Oda 1, Kiosk",
      "device-name-hint": "Bridge panosundaki tanımlama için ad",
      "kim-address": "KIM Adresi (isteğe bağlı)",
      "kim-address-placeholder": "praxis@musterpraxis.kim.telematik",
      "kim-address-hint": "This device only. Leave empty to use the practice KIM address.",
      "test": "Test",
      "success": "Bağlantı başarılı",
      "error": "Bağlantı başarısız",
      "api-unreachable": "DocCirrus API'ye erişilemiyor",
      "status-title": "Bağlantı Durumu",
      "status": {
        "api": "API bağlandı",
        "ti": "Telematik altyapısı",
        "card-reader": "Kart okuyucu mevcut",
        "medical-card": "Muayenehane kartı (SMC-B/HBA)"
      },
      "kim-address-consequence": "At Online Check-in the insurer sends the insured person’s data to this address instead of the practice address.",
      "kim-address-practice": "Practice address",
      "kim-address-confirm-title": "Change the KIM address for this device?",
      "kim-address-confirm-description": "At Online Check-in the insurer will send the insured person’s data to this address from now on.",
      "kim-address-confirm-previous": "Current",
      "kim-address-confirm-next": "New",
      "kim-address-confirm-cancel": "Cancel",
      "kim-address-confirm-accept": "Change address",
      "sol-token": "Sol token (inSuite'ten)",
      "sol-token-hint": "inSuite'teki Bridge yönetiminden kopyalayın. Bağlantı için gereklidir.",
      "sol-token-show": "Token'ı göster",
      "sol-token-hide": "Token'ı gizle",
      "bridge-unreachable": "Bridge'e ulaşılamıyor. Lütfen adresi ve bağlantı noktasını kontrol edin.",
      "diagnostic-id": "Tanılama kimliği: {{id}}",
      "scan-qr": "QR kodu tara",
      "scan-title": "Bridge QR kodunu tara",
      "scan-manual": "Elle gir"
    },
    "terminal": {
      "title": "Kart Okuyucu",
      "description": "Telematik altyapı için kart okuyucu seçimi",
      "select": "Terminal Seç",
      "select-placeholder": "Terminal seçin...",
      "loading": "Terminaller yükleniyor...",
      "none-available": "Terminal mevcut değil",
      "none-found": "Terminal bulunamadı",
      "found": "{{count}} terminal bulundu",
      "connect-hint": "Terminalleri yüklemek için önce bridge sunucusuna bağlanın.",
      "found-count": "Bulunan kart okuyucular: {{count}}",
      "refresh": "Kart okuyucuları yeniden yükle"
    },
    "practice": {
      "title": "Muayenehane",
      "description": "Muayenehaneniz hakkında bilgiler",
      "name": "Muayenehane adı",
      "name-placeholder": "örn. Dr. Ahmet Yılmaz",
      "welcome-message": "Hoş Geldiniz Mesajı",
      "welcome-placeholder": "örn. Muayenehanemize hoş geldiniz",
      "scheduler-available": "Zamanlayıcıyı Etkinleştir",
      "scheduler-available-description": "Hastaların self-servis terminal aracılığıyla randevu almasına izin verilmesi",
      "prescription-available": "Reçete Hizmetini Etkinleştir",
      "prescription-available-description": "Patients can request repeat prescriptions at the self-service terminal. The practice reviews every request.",
      "welcome-hint": "Boş bırakın: Karşılama hastanın kendi dilinde gösterilir. Kendi metniniz her dilde değiştirilmeden gösterilir."
    },
    "patient-info": {
      "eyebrow": "Patient information review",
      "description": "Applies practice-wide to every FrontDesk+ terminal and is enforced by the server.",
      "enabled": "Show the review after reading the health card",
      "phone": "Review telephone numbers",
      "email": "Review email addresses",
      "hausarzt": "Review primary physician",
      "selection-required": "Select at least one item to review.",
      "save": "Save review setting",
      "saved": "Review settings saved.",
      "conflict": "The setting changed in the meantime. The current version has been loaded.",
      "save-error": "The review settings could not be saved.",
      "unavailable": "The practice-wide setting is currently unavailable.",
      "scope": "Practice-wide · Server",
      "scope-description": "Stored on the practice server and enforced for all terminals.",
      "sentence-off": "The review is switched off. Patients are not asked about their contact details at the terminal.",
      "last-saved": "Last saved on the server: {{value}}",
      "never-saved": "Never saved on the server.",
      "last-saved-all": "Tüm cihazlar için kaydedildi: {{value}}",
      "never-saved-default": "Varsayılan ayar, henüz değiştirilmedi."
    },
    "anamnesis": {
      "title": "Dijital Tıp Tarihi",
      "description": "Check-in sonrasında tıbbi geçmiş sağlayıcınıza bir bağlantı ve QR code gösterir.",
      "enabled": "Girişten sonra tıbbi geçmiş bağlantısını göster",
      "enabled-description": "Check-in tamamlandıktan sonra tıbbi geçmiş sağlayıcınıza (örneğin, Nelly) bir bağlantı ve QR code gösterir.",
      "url": "Tıbbi geçmiş sağlayıcı bağlantısı",
      "url-hint": "Bağlantı tüm hastalar için statik ve aynıdır.",
      "preview-label": "Tamamlama ekranı önizlemesi",
      "preview-note": "Bağlantı tüm hastalar için statik ve aynıdır.",
      "url-first": "Açmak için önce geçerli bir bağlantı girin."
    },
    "appearance": {
      "title": "Görünüm",
      "description": "Kullanıcı arayüzünü özelleştirin",
      "language": "Dil",
      "default-kiosk-language": "Varsayılan Hasta Dili",
      "default-kiosk-language-hint": "Hastalar için yeni kiosk oturumlarının başlatılacağı dil.",
      "voice-over-volume": "Seslendirme Sesi",
      "voice-over-hint": "Erişilebilirlik için seslendirme asistanının ses seviyesini kontrol eder.",
      "language-first": "Oturum başında dil seçimini göster"
    },
    "security": {
      "title": "Güvenlik",
      "description": "Ayarlara erişim için PIN",
      "pin": "PIN",
      "pin-hint": "4-8 digits. At least 4 digits, and not 0000."
    },
    "eyebrow": "Kiosk yönetimi",
    "nav": {
      "general": "Genel",
      "flows": "İşlevler",
      "anamnese": "Dijital anamnez",
      "device": "Cihaz ve bağlantı"
    },
    "flows": {
      "title": "Terminaldeki işlevler"
    },
    "language": {
      "title": "Dil ve sesli okuma",
      "description": "Bu cihazdaki hastalar için dil ve sesli okuma."
    }
  },
  "self-service": {
    "title": "Self-Servis",
    "step-progress": "Adım {{current}} / {{total}}",
    "flows": {
      "checkin": "Kayıt",
      "scheduler": "Randevu Al",
      "prescription": "Reçeteler",
      "locations": "Konum Haritası",
      "emergency": "Acil"
    },
    "audio-guide": {
      "on": "Ses açık",
      "off": "Ses kapalı",
      "replay": "Yönergeyi tekrar oynat",
      "replay-unavailable": "Tekrar oynatılacak sesli yönerge yok"
    },
    "language-selector": {
      "title": "Dil Seçin",
      "description": "Lütfen tercih ettiğiniz dili seçin"
    },
    "settings": "Ayarlar",
    "start": {
      "welcome": "Hoş Geldiniz",
      "subtitle": "Lütfen bir seçenek seçin",
      "check-in-label": "Ana yol",
      "check-in-cta": "Kayıt",
      "check-in-description": "Randevunuz var mı? Buradan kayıt olun.",
      "check-in-hint": "Kartınızı hazır bulundurun",
      "scheduler-label": "Yeni",
      "scheduler-cta": "Randevu Al",
      "scheduler-description": "Yeni randevu alın.",
      "location-plan": "Konum Haritası",
      "location-plan-description": "Tedavi odasına giden yolu bulun.",
      "prescription-label": "Zamanaşımı",
      "prescription-cta": "Reçeteler ve Sipariş",
      "prescription-description": "Reçeteleri görüntüleyin veya yedek sipariş verin.",
      "emergency-cta": "Yerel acil durum uyarısı",
      "emergency-description": "Yalnızca bu cihazda ses çıkarır; yardım çağırmaz.",
      "tap-to-start": "Başlamak için dokunun"
    },
    "offline": {
      "banner-title": "Giriş geçici olarak yapılamıyor",
      "banner-message": "Yardım için lütfen resepsiyon personeliyle görüşün.",
      "emergency-available": "Yerel uyarı kullanılabilir durumda. Yardım çağırmaz.",
      "flow-disabled": "Geçici olarak kullanılamıyor"
    },
    "readability": {
      "toggle-label": "Okuma modu",
      "on": "Okuma modu",
      "off": "Okuma modu"
    },
    "reset-overlay": {
      "timeout-title": "Oturum sona erdi",
      "timeout-subtitle": "Süreniz doldu. Verileriniz güvende.",
      "offline-title": "Bağlantı kesildi",
      "offline-subtitle": "Bağlantı kesildi. Lütfen resepsiyon personeli ile konuşun.",
      "interruption-title": "Oturum sona erdi",
      "interruption-subtitle": "Oturumunuz güvenli bir şekilde sonlandırıldı.",
      "completion-title": "Teşekkürler!",
      "completion-subtitle": "Talebiniz başarıyla tamamlandı.",
      "reassurance": "Kişisel verileriniz bu cihazda saklanmamaktadır.",
      "auto-dismiss": "{{seconds}} saniye içinde başlangıca dönülüyor...",
      "dismiss": "Başa git"
    },
    "timed-terminal": {
      "countdown": "{{seconds}} saniye içinde otomatik dönüş",
      "countdown-outcome": "Bu terminal otomatik olarak başlangıç ekranına dönecektir.",
      "more-time": "Daha fazla zaman",
      "extended": "Süre uzatıldı"
    },
    "scheduler": {
      "questionnaire": {
        "language-unavailable": "Bu sorular dilinizde mevcut değil. Lütfen sunulan dillerden birini seçin veya danışmaya başvurun.",
        "alternatives": "Alternatif randevular",
        "loading": "Sorular yükleniyor…",
        "reception-fallback": "Lütfen resepsiyona başvurun.",
        "error-title": "Sorular yüklenemedi",
        "language-unavailable-lead": "Bu sorular sizin dilinizde mevcut değil.",
        "language-unavailable-title": "Lütfen bu dillerden birini seçin",
        "language-unavailable-body": "Ya da resepsiyondan yardım isteyin."
      },
      "start": {
        "title": "Randevu Al",
        "subtitle": "Birkaç adımda randevunuzu alın",
        "welcome": "Randevu Alma'ya Hoş Geldiniz",
        "description": "Size randevu alma sürecinde rehberlik edeceğiz",
        "cta": "Şimdi randevu al"
      },
      "patient-id": {
        "title": "Kimlik",
        "subtitle": "Lütfen kendinizi tanıtın",
        "mode-card": "Kartla",
        "mode-search": "Ara",
        "mode-create": "Yeni oluştur",
        "insert-card": "Lütfen sigorta kartınızı takın",
        "reading-card": "Kart okunuyor...",
        "simulate-card": "Kartı simüle et",
        "multiple-matches": "Birden fazla hasta bulundu. Kart verileri kullanılıyor.",
        "search-placeholder": "Ad veya sigorta numarası...",
        "searching": "Aranıyor...",
        "no-results": "Sonuç bulunamadı",
        "first-name": "Ad",
        "last-name": "Soyad",
        "dob": "Doğum tarihi",
        "insurance": "Sigorta",
        "continue": "Devam et",
        "creating": "Hasta oluşturuluyor...",
        "patient-created": "Hasta başarıyla oluşturuldu!",
        "create-error": "Hasta oluşturulamadı."
      },
      "appointment-type": {
        "title": "Randevu Türünü Seçin",
        "subtitle": "Lütfen ziyaret nedeninizi seçin",
        "loading": "Randevu türleri yükleniyor...",
        "no-types": "Randevu türü mevcut değil",
        "error": "Randevu türleri yüklenemedi. Lütfen tekrar deneyin.",
        "no-bookable": "Bu randevu türleri şu anda kiosktan alınamıyor. Lütfen resepsiyona başvurun veya telefonla randevu alın.",
        "disabled-default": "Lütfen bu randevuyu doğrudan resepsiyonda veya telefonla ayarlayın.",
        "disabled-footer": "Yalnızca resepsiyon/telefon",
        "lead": "Ne tür bir randevu almak istiyorsunuz?",
        "duration": "yakl. {{minutes}} dakika",
        "empty-title": "Burada şu anda randevu alınamıyor",
        "none-bookable-title": "Bu randevuları burada alamazsınız",
        "none-bookable-body": "Lütfen resepsiyona sorun veya bizi arayın."
      },
      "types": {
        "general": "Genel Muayene",
        "general-desc": "Genel şikayetler ve sorular için",
        "checkup": "Önleyici Kontrol",
        "checkup-desc": "Düzenli sağlık kontrolleri",
        "vaccination": "Aşı",
        "vaccination-desc": "Aşı randevusu alın",
        "followup": "Takip",
        "followup-desc": "Kontrol randevusu",
        "prescription": "Reçete",
        "prescription-desc": "Reçete alma"
      },
      "slot-selection": {
        "title": "Randevu Seçin",
        "subtitle": "Lütfen uygun bir randevu seçin",
        "loading": "Uygun randevular yükleniyor...",
        "no-slots": "Uygun randevu yok",
        "no-appointment-type": "Randevu türü seçilmedi",
        "error": "Uygun slotlar yüklenemedi. Lütfen tekrar deneyin.",
        "quick-select": "Sonraki uygun randevular:",
        "select-date": "Veya bir tarih seçin:",
        "times-for": "{{date}}",
        "available": "Uygun",
        "unavailable": "Slot yok",
        "slots": "slotlar",
        "select-time-hint": "Randevunuzu almak için bir saate dokunun",
        "week-short": "Hf",
        "weekday-mon": "Pzt",
        "weekday-tue": "Sal",
        "weekday-wed": "Çar",
        "weekday-thu": "Per",
        "weekday-fri": "Cum",
        "weekday-sat": "Cmt",
        "weekday-sun": "Paz",
        "period-morning": "Sabah",
        "period-midday": "Öğle",
        "period-afternoon": "Öğleden sonra",
        "period-evening": "Akşam",
        "period-morning-short": "Sabah",
        "period-midday-short": "Öğle",
        "period-afternoon-short": "Öğl.S.",
        "period-evening-short": "Akşam",
        "period-dots-legend": "Zaman uygunluğu",
        "filter-hint": "Tercih edilen zamanlara göre filtrele:",
        "or-choose-below": "veya aşağıyı seçin",
        "no-slots-period": "Slot yok",
        "show-all": "Tümünü göster",
        "free": "ücretsiz",
        "your-selection": "Seçiminiz",
        "oclock": "saat",
        "choose-slot": "Slot seç",
        "choose-day": "Gün seçin",
        "choose-day-first": "Lütfen önce bir gün seçin",
        "times-heading": "{{date}} için boş saatler",
        "time-value": "{{time}}",
        "empty-title": "{{month}} ayında boş randevu yok",
        "empty-body": "Sonraki aya bakın veya resepsiyona sorun – memnuniyetle yardımcı oluruz.",
        "next-month": "Sonraki ay",
        "previous-month": "Önceki ay"
      },
      "confirmation": {
        "patient-responses": "Yanıtlarınız",
        "review-loading": "Özet kontrol ediliyor…",
        "review-unavailable": "Özet kullanılamıyor. Lütfen tekrar deneyin veya resepsiyona sorun.",
        "check-booking": "Randevu durumunu kontrol et",
        "title": "Randevuyu Onayla",
        "subtitle": "Lütfen rezervasyonunuzu gözden geçirin",
        "patient": "Hasta",
        "datetime": "Tarih ve saat",
        "booking": "Rezervasyon yapılıyor...",
        "confirm": "Randevuyu al",
        "heading": "Bu doğru görünüyor mu?",
        "lead": "Lütfen randevunuzu onaylayın.",
        "appointment": "Randevu",
        "insured-via": "Sigortalı",
        "description-label": "Muayenehane için notlar (isteğe bağlı)",
        "description-hint": "Randevu planlama veya giriş kaydı sırasında dikkate almamız gereken bir şey varsa bize bildirin.",
        "description-placeholder": "örn. kısıtlı hareketlilik, refakatçi, önemli notlar",
        "description-too-long": "Lütfen notu en fazla 500 karakterle sınırlayın.",
        "summary": "Özet",
        "change": "Değişiklik",
        "book-binding": "Randevu alın",
        "cancel": "İptal",
        "type-label": "Randevu türü",
        "datetime-value": "{{date}}, saat {{time}}",
        "name-label": "Ad",
        "insurance-label": "Sigorta",
        "insurance-GKV": "Yasal sağlık sigortası",
        "insurance-PKV": "Özel sağlık sigortası",
        "insurance-SELFPAY": "Kendi ödeyen",
        "change-time": "Randevuyu değiştir",
        "description-free-text": "Diğer notlar (isteğe bağlı)",
        "note-wheelchair": "Tekerlekli sandalye kullanıyorum",
        "note-companion": "Refakatçiyle geliyorum",
        "note-interpreter": "Tercümana ihtiyacım var"
      },
      "done": {
        "title": "Randevu Alındı!",
        "label": "Rezerve edildi",
        "subtitle": "Randevunuz başarıyla alındı.",
        "date": "Tarih",
        "time": "Saat",
        "booking-id": "Rezervasyon numarası",
        "qr-hint": "Takviminize ekleyin",
        "qr-description": "Bu QR kodunu akıllı telefon kameranızla tarayarak randevuyu takvim uygulamanıza ekleyin",
        "auto-redirect": "Kısa süre içinde başlangıç sayfasına yönlendirileceksiniz...",
        "auto-redirect-countdown": "{{seconds}} saniye içinde başlangıca dönülüyor...",
        "back-to-start": "Başlangıca dön",
        "print-button": "Randevu belgesini yazdır",
        "print-preparing": "Yazdırma görünümü hazırlanıyor…",
        "print-error": "Randevu belgesi açılamadı. Lütfen tekrar deneyin veya resepsiyondan yardım isteyin.",
        "print-returned": "Sistem yazdırma görünümü kapatıldı. Gerekirse başka bir kopya isteyebilirsiniz.",
        "print-title": "Randevunuz",
        "print-location": "Konum",
        "print-map-hint": "Konumu telefonunuzda açın",
        "print-error-v2": "Randevu fişi açılamadı. Lütfen tekrar deneyin veya resepsiyona sorun."
      },
      "error": {
        "assistance-info": "Rezervasyonunuzu onaylayamadık. Randevunuz zaten alınmış olabilir. Lütfen resepsiyona sorun.",
        "pending-title": "Rezervasyon onaylanmadı",
        "pending-info": "Rezervasyonunuzu onaylayamadık. Randevunuz zaten alınmış olabilir. Lütfen tekrar kontrol edin veya resepsiyona sorun.",
        "title": "Rezervasyon Başarısız",
        "subtitle": "Randevu alınamadı.",
        "info": "Lütfen tekrar deneyin veya resepsiyona sorun."
      },
      "phase": {
        "identify": "Giriş",
        "choose": "Saat seçimi",
        "confirm": "Onay"
      }
    },
    "prescription": {
      "start": {
        "title": "Reçeteler ve Sipariş",
        "subtitle": "Reçeteleri görüntülemek veya yedek sipariş vermek için sigorta kartınızı takın.",
        "button": "Kart Ekle"
      },
      "card-check": {
        "loading": "Kart okuyucu yükleniyor...",
        "no-terminal": "Kart okuyucu yapılandırılmadı",
        "no-terminal-hint": "Yardım için lütfen personelle iletişime geçin.",
        "insert-card": "Lütfen kartınızı takın",
        "insert-card-hint": "Sigorta kartınızı kart okuyucuya takın.",
        "card-detected": "Kart algılandı",
        "reading": "Kart okunuyor...",
        "reading-hint": "Lütfen biraz bekleyin.",
        "error": "Kart okunurken hata oluştu",
        "retry": "Tekrar deneyin",
        "manual-lookup": "Kartsız devam et",
        "load-error": "Kart okuyucu yüklenemedi",
        "read-error": "Kart okunamadı"
      },
      "patient-selection": {
        "title": "Hasta Seç",
        "subtitle": "Birden fazla hasta bulundu. Lütfen adınızı seçin.",
        "try-again": "Tekrar deneyin",
        "try-again-hint": "Kartı tekrar takın"
      },
      "list": {
        "title": "Reçeteleriniz",
        "for-patient": "{{name}} Reçeteleri",
        "loading": "Reçeteler yükleniyor...",
        "error-title": "Yükleme Hatası",
        "fetch-error": "Reçeteler yüklenemedi",
        "back-home": "Başa Dön",
        "done": "Yapıldı"
      },
      "detail": {
        "prescription-info": "Reçete Bilgileri",
        "date": "Tarih",
        "prescriber": "Reçeteci",
        "comment": "Not",
        "medications": "İlaçlar",
        "form": "Formu",
        "pack-size": "Paket Boyutu",
        "manufacturer": "Üretici",
        "loading": "Reçete yükleniyor...",
        "fetch-error": "Reçete detayları yüklenemedi",
        "back-to-list": "Listeye Geri Dön",
        "print": "Yazdır"
      },
      "types": {
        "public": "Kamu Reçetesi",
        "private": "Özel Reçete",
        "long-term": "Uzun Süreli Zamanaşımı",
        "btm": "Narkotik Reçetesi",
        "g": "Yeşil Reçete",
        "t": "T-Reçete"
      },
      "no-patient": {
        "title": "Hasta Bulunamadı",
        "subtitle": "Maalesef bu karta uygun hasta bulunamadı. Yardım için lütfen personelle iletişime geçin.",
        "try-again": "Tekrar Deneyin",
        "back-home": "Başa Dön",
        "title-v2": "Eşleşen bilgi bulunamadı",
        "subtitle-v2": "Sizi bulamadık. Lütfen tekrar deneyin veya resepsiyona sorun."
      },
      "done": {
        "title": "Teşekkürler",
        "subtitle": "Şimdi oturabilirsiniz. Sorularınız varsa lütfen personelle iletişime geçin.",
        "no-prescriptions-title": "Dosyada reçete yok",
        "no-prescriptions-subtitle": "Sizin için aktif bir reçete bulamadık. Böyle bir beklentiniz varsa lütfen resepsiyon personeliyle iletişime geçin.",
        "error-title": "Bir Hata Oluştu",
        "error-subtitle": "Daha fazla yardım için lütfen personelle iletişime geçin.",
        "auto-redirect": "{{seconds}} saniye içinde otomatik yönlendirme",
        "finish": "Başa Dön"
      },
      "hub": {
        "title": "Reçeteleriniz",
        "for-patient": "{{name}} Reçeteleri",
        "loading": "Reçeteler yükleniyor...",
        "error-title": "Yükleme Hatası",
        "fetch-error": "Reçeteler yüklenemedi",
        "back-home": "Başa Dön",
        "done": "Yapıldı",
        "order-button": "Sipariş Zamanaşımı",
        "existing-prescriptions": "Mevcut reçeteleriniz",
        "no-prescriptions": "Aktif reçete bulunamadı."
      },
      "patient-lookup": {
        "title": "Hasta Bul",
        "subtitle": "Adınızı ve doğum tarihinizi girin.",
        "last-name": "Soyadı",
        "first-name": "Ad",
        "date-of-birth": "Doğum Tarihi",
        "lastname": "Soyadı",
        "lastname-placeholder": "Soyadınız",
        "firstname": "Ad",
        "firstname-placeholder": "Adınız",
        "dob": "Doğum Tarihi",
        "search": "Ara",
        "searching": "Aranıyor...",
        "search-error": "Arama hatası: {{message}}",
        "no-match": "Hasta bulunamadı. Lütfen bilgilerinizi kontrol edin.",
        "error": "Arama hatası. Lütfen tekrar deneyin.",
        "found": "Hasta bulundu",
        "confirm": "Onayla",
        "ambiguous": "Çoklu eşleşme",
        "ambiguous-hint-firstname": "Aramayı hassaslaştırmak için lütfen adınızı da girin.",
        "ambiguous-hint-additional": "Lütfen bilgilerinizi kontrol edin veya personelimiz ile iletişime geçin.",
        "not-found": "Hasta bulunamadı",
        "not-found-hint": "Bu detaylara sahip hasta bulunamadı.",
        "not-found-action": "Tekrar deneyin"
      },
      "manual-identification": {
        "unverified": "Kimliğiniz sağlık sigortası kartıyla doğrulanmadı. Muayenehane, işleme almadan önce bilgilerinizi ve talebinizi kontrol edecektir."
      },
      "medication-selection": {
        "title": "Reçete isteyin",
        "subtitle": "Muayenehane talebinizi inceler. Onaylandıktan sonra eRx, e-prescription uygulamanızda hazır olur.",
        "back": "Geri",
        "submit": "İncelemeye devam et",
        "reason-title": "Neden reçeteye ihtiyacınız var?",
        "reason-hint": "Muayenehanenin talebinizi değerlendirmesine yardımcı olur.",
        "reason-validation": "Lütfen bir neden seçin.",
        "reason-schmerzen": "Acı",
        "reason-entzuendung": "İltihap",
        "reason-nachsorge": "Ameliyat sonrası / prosedürü",
        "reason-allergie": "Alerji / reaksiyonu",
        "reason-chronisch": "Kronik durum",
        "reason-anderes": "Başka bir şey",
        "medications-title": "Hangi ilaçlar?",
        "request-hint": "Neye ihtiyacınız olduğunu açıklayın veya yenilenmesini istediğiniz önceki reçetenin adını verin.",
        "request-placeholder": "ör. İbuprofen 600 mg, geçen seferkiyle aynı",
        "request-validation": "Lütfen hangi ilaca ihtiyacınız olduğunu açıklayın.",
        "history-title": "Önceki reçeteler",
        "history-hint": "İsteğinizi önceden doldurmak için bir giriş ekleyin.",
        "history-loading": "Önceki reçeteler yükleniyor...",
        "history-error": "Önceki reçeteler yüklenemedi.",
        "history-add": "Ekle",
        "history-added": "Eklendi",
        "history-date": "Son: {{date}}",
        "history-request-line": "Yenile: {{medicationName}}",
        "urgency-title": "Ne kadar acil?",
        "urgency-hint": "Muayenehanenin önceliklendirmesine yardımcı olur.",
        "urgency-soon": "Acil",
        "urgency-soon-meta": "En kısa sürede",
        "urgency-tomorrow": "Yakında",
        "urgency-tomorrow-meta": "Önümüzdeki birkaç gün içinde",
        "urgency-week": "Bu hafta",
        "urgency-week-meta": "Zaman baskısı yok",
        "lead": "Muayenehane talebinizi inceler. Onaydan sonra e-reçetenizi e-reçete uygulamasında veya sağlık sigortası kartınızda bulursunuz.",
        "history-hint-v2": "Eklemek için önceki bir reçeteye dokunun.",
        "history-retry": "Yeniden yükle"
      },
      "request-review": {
        "title": "İnceleme Kararı",
        "subtitle": "Lütfen reçete talebinizi gözden geçirin.",
        "request-label": "Talep edilen ilaç",
        "selected-medications": "Seçilmiş İlaçlar",
        "free-text-medications": "Ek İlaçlar",
        "freetext-label": "Diğer",
        "quarterly-warning": "Sigorta kartınız bu çeyrekte okunmadı. Muayenehane sizinle iletişime geçebilir.",
        "egk-warning": "Sigorta kartınız bu çeyrekte okunmadı. Muayenehane sizinle iletişime geçebilir.",
        "submit": "Gönder",
        "submitting": "Gönderiliyor...",
        "submit-error": "İstek gönderilemedi. Lütfen tekrar deneyin.",
        "back": "Geri",
        "reason-label": "Gerekçe",
        "urgency-label": "Aciliyet",
        "completion-email-choice": "Muayenehane talebimi işlediğinde e-posta almak istiyorum.",
        "completion-email-label": "E-posta adresi",
        "completion-email-placeholder": "ad@ornek.com",
        "completion-email-hint": "Yalnızca bu tek seferlik mesaj için. Adres ana verilere kaydedilmez.",
        "completion-email-invalid": "Lütfen geçerli bir e-posta adresi girin.",
        "egk-proof-required": "Reçete talepleri yalnızca sigorta kartı başarıyla okunduktan sonra mümkündür. Lütfen personele başvurun.",
        "title-v2": "Talebi kontrol et",
        "completion-email-hint-v2": "Adres yalnızca bu tek mesaj için kullanılır."
      },
      "confirmation": {
        "title": "İstek Gönderildi",
        "subtitle": "Reçete talebiniz başarıyla iletildi.",
        "success-title": "İstek Gönderildi",
        "success-subtitle": "Reçete talebiniz başarıyla iletildi.",
        "estimated-time": "Reçeteniz yaklaşık olarak {{time}} içerisinde hazır olacaktır.",
        "info": "Reçetenizi sigorta kartınız veya eRezept uygulamasıyla eczaneden alabilirsiniz.",
        "auto-redirect": "{{seconds}} saniye içinde otomatik yönlendirme",
        "back-to-start": "Başa Dön",
        "handling-label": "Handled by the practice",
        "next-steps": "Muayenehane talebinizi inceler. Onaydan sonra e-reçetenizi eczanede sağlık sigortası kartınızla veya e-reçete uygulamasıyla alabilirsiniz."
      },
      "phase": {
        "identify": "Giriş",
        "request": "Talep",
        "review": "Kontrol"
      }
    },
    "check-in": {
      "flow-label": "Giriş",
      "has-appointment": {
        "eyebrow": "Randevu",
        "title": "Randevunuz var mı?",
        "subtitle": "Lütfen bir seçenek seçin",
        "yes-label": "Evet",
        "yes": "Evet, randevum var",
        "yes-description": "Randevum için kayıt olmak istiyorum.",
        "yes-hint": "En hızlı yol",
        "unsure-label": "Belki",
        "unsure": "Emin değilim",
        "unsure-description": "Sizin için kontrol edeceğiz.",
        "unsure-hint": "Seni arayacağız",
        "no-label": "Hayır",
        "no": "Hayır, randevusuz",
        "no-description": "Randevum yok.",
        "no-hint": "Rezervasyonsuz Giriş"
      },
      "card-check": {
        "eyebrow": "Sigorta kartı",
        "title": "Sigorta Kartını Okut",
        "subtitle": "Lütfen sigorta kartınızı okuyucuya takın",
        "insert-title": "Sağlık sigortası kartınızı kart okuyucuya takın.",
        "insert-detail": "Bilgilerinizi otomatik olarak okuyoruz; başka bir şey yapmanıza gerek yok.",
        "other-ways": "Diğer yollar",
        "no-card-hint": "Kartınız şu anda yanınızda değilse.",
        "pkv-hint": "QR code'i sigorta uygulamanızla kullanın.",
        "loading": "Ayarlar yükleniyor...",
        "no-terminal": "Kart okuyucu yapılandırılmamış. Lütfen personelle iletişime geçin.",
        "checking": "Kartlar kontrol ediliyor...",
        "insert-prompt": "Lütfen kartı takın...",
        "card-detected": "Kart algılandı! Okumaya hazır.",
        "read-card": "Kartı Oku",
        "simulate-insert": "Kartı simüle et",
        "reading": "Kart okunuyor...",
        "error": "Kart okunamadı. Lütfen tekrar deneyin.",
        "read-error": "Kart verileri okunamadı. Lütfen tekrar deneyin.",
        "settings-error": "Ayarlar yüklenemedi. Lütfen tekrar deneyin.",
        "no-card-prompt": "Kartınız yok mu?",
        "no-card-action": "Manuel arama",
        "connection-warning": "Kart okuyucuyla bağlantı sorunları. Lütfen bekleyin...",
        "pkv-prompt": "Özel sigorta mı? Online Check-in",
        "pkv-instruction": "Verilerinizi dijital olarak iletmek için bu QR code'i özel sağlık sigortası uygulamanızla tarayın.",
        "pkv-continue": "Manuel kayda devam et",
        "unreadable-title": "Card detected, but no insurance data could be read.",
        "unreadable-body": "Please try again or go to the reception desk. You can also check in without your card.",
        "unreadable-help": "Lütfen tekrar deneyin veya kartsız kayıt olun. Resepsiyon size memnuniyetle yardımcı olur.",
        "title-pkv": "Uygulama ile kayıt",
        "title-reading": "Kartınız okunuyor …",
        "title-unreadable": "Kart okunamadı",
        "title-no-terminal": "Kartsız kayıt",
        "no-terminal-body": "Kart okuyucu şu anda kullanılamıyor. Lütfen kartsız kayıt olun veya resepsiyona başvurun.",
        "reading-detail": "Lütfen kartı okuyucuda bırakın. Sadece bir an sürer.",
        "other-ways-title": "Diğer seçenekler",
        "no-card-title": "Kartsız kayıt ol",
        "pkv-prompt-title": "Özel sigortalı mısınız?",
        "pkv-prompt-hint": "Özel sağlık sigortanızın uygulaması ile kayıt",
        "pkv-close": "Yine de kartla",
        "pkv-instruction-app": "Özel sağlık sigortanızın uygulamasını açın ve bu kodu okutun. Bilgileriniz doğrudan bize gelir."
      },
      "patient-selection": {
        "title": "Hasta Seçin",
        "subtitle": "Birden fazla hasta bulundu. Lütfen kendinizi seçin.",
        "firstname-label": "Adınız",
        "firstname-placeholder": "Adını girin...",
        "confirm-button": "Onayla",
        "no-match": "Eşleşen hasta bulunamadı. Lütfen yardım için resepsiyona gidin.",
        "still-ambiguous": "Birden fazla eşleşme kaldı. Lütfen yardım için resepsiyona gidin.",
        "select-error": "Hastanın kimliği belirlenemedi. Lütfen tekrar deneyin.",
        "staff-assist": "Resepsiyona git",
        "title-v2": "Kısa bir soru",
        "subtitle-v2": "Güvenliğiniz için lütfen adınızı girin.",
        "no-match-v2": "Sizi bu adla bulamadık. Yazımı kontrol edin veya resepsiyona başvurun.",
        "still-ambiguous-v2": "Sizi henüz kesin olarak bulamadık. Lütfen resepsiyona başvurun.",
        "select-error-v2": "Maalesef olmadı. Lütfen tekrar deneyin."
      },
      "card-checkin": {
        "title": "Kaydı Onayla",
        "subtitle": "Verileriniz başarıyla okundu.",
        "confirm": "Kaydı onayla"
      },
      "register-from-card": {
        "title": "Yeni Kayıt",
        "subtitle": "Henüz sistemimizde değilsiniz. Kayıt olmak ister misiniz?",
        "card-data": "Kart Verileri",
        "create": "Kayıt ol",
        "create-error": "Kayıt başarısız oldu. Lütfen tekrar deneyin veya personelden yardım isteyin.",
        "staff-assist": "Personeli Ara",
        "no-card-data-title": "Kart Verisi Yok",
        "no-card-data": "Kartınızdaki veriler okunamıyor.",
        "insurance-verified": "Sigorta doğrulandı: {{insurer}}",
        "insurer-missing": "The card does not contain a cost-carrier identifier. Registration via the card is not possible. Please go to the reception desk.",
        "title-v2": "Karttaki bilgileriniz",
        "subtitle-v2": "Lütfen bilgilerinizi kontrol edin. Bir şey yanlışsa „Değiştir\"e dokunun.",
        "create-v2": "Bilgileri onayla",
        "create-error-v2": "Kayıt maalesef olmadı. Tekrar deneyin veya resepsiyona başvurun.",
        "insurer-missing-v2": "Kartınızda sağlık sigortası bilgisi yok. Lütfen resepsiyona başvurun.",
        "edit": "Değiştir",
        "name": "Ad",
        "insurer": "Sağlık sigortası"
      },
      "patient-lookup": {
        "title": "Hasta Ara",
        "subtitle": "Lütfen adınızı veya sigorta numaranızı girin.",
        "lastname": "Soyadı",
        "lastname-placeholder": "Soyadınız",
        "dob": "Doğum tarihi",
        "firstname": "Ad",
        "firstname-placeholder": "Adınız",
        "search": "Ara",
        "searching": "Aranıyor...",
        "search-placeholder": "Ad veya sigorta numarası...",
        "results-placeholder": "Arama sonuçları burada görünecek",
        "found": "Hasta bulundu!",
        "confirm-identity": "Lütfen gösterilen hastanın siz olduğunuzu doğrulayın.",
        "confirm-button": "Bu benim",
        "ambiguous-firstname": "Birden fazla hasta bulundu. Lütfen adınızı girin.",
        "ambiguous-additional": "Birden fazla hasta bulundu. Lütfen personelle iletişime geçin.",
        "disambiguation-hint": "Bu sizi açıkça tanımlamamıza yardımcı olur.",
        "not-found": "Bu detaylara sahip hasta bulunamadı.",
        "error": "Arama hatası: {{message}}",
        "staff-assist": "Personeli arayın",
        "not-found-prompt": "Bulunamadı mı?",
        "register-new": "Yeni kayıt",
        "not-found-hint": "No patient could be found with these details.",
        "create-new": "Register new patient",
        "dob-placeholder": "DD.MM.YYYY",
        "dob-picker": "Choose date of birth in the calendar",
        "title-v2": "Kartsız kayıt",
        "subtitle-firstname": "Lütfen adınızı da girin.",
        "ambiguous-firstname-v2": "Bu soyadına sahip birden fazla kişi var. Lütfen adınızı da girin.",
        "search-again": "Tekrar ara",
        "found-v2": "Sizi bulduk",
        "found-confirm": "Lütfen „Bu benim\" ile onaylayın.",
        "not-found-title": "Sizi bulamadık",
        "not-found-check": "Yazımı ve doğum tarihini kontrol edin. Resepsiyon size memnuniyetle yardımcı olur.",
        "not-found-reception": "Yazımı ve doğum tarihini kontrol edin veya resepsiyona başvurun.",
        "ambiguous-additional-v2": "Sizi kesin olarak bulamadık. Lütfen resepsiyona başvurun.",
        "error-v2": "Arama şu anda olmadı. Lütfen tekrar deneyin."
      },
      "checking-in": {
        "title": "Bir dakika — kaydınızı yapıyoruz.",
        "subtitle": "Sizi tedavi sırasına ekliyoruz ve ekibe bildiriyoruz.",
        "step-insurance": "Sigorta kontrol edildi",
        "step-appointment": "Randevu onaylandı",
        "step-waitlist": "Bekleme listesine ekleniyor",
        "error": "Giriş başarısız oldu. Lütfen tekrar deneyin.",
        "continue": "Yine de devam et",
        "title-v2": "Bir dakika lütfen",
        "loading": "Kaydınızı yapıyoruz …",
        "subtitle-v2": "Sizi bekleme listesine ekliyor ve ekibe haber veriyoruz.",
        "error-title": "Maalesef olmadı",
        "error-v2": "Kaydınız tamamlanamadı.",
        "error-body": "Lütfen tekrar deneyin. Yine olmazsa resepsiyon size yardımcı olur."
      },
      "appointment-selection": {
        "title": "Randevu seçin",
        "subtitle": "Bugün birden fazla randevunuz var. Lütfen birini seçin.",
        "checking-in": "Giriş yapılıyor...",
        "time": "{{time}}",
        "error-v2": "Bu randevu için kayıt olmadı. Tekrar deneyin veya resepsiyona başvurun."
      },
      "no-appointment": {
        "title": "Randevu bulunamadı",
        "subtitle": "Bugün size randevu bulamadık. Lütfen düzenli randevu alın.",
        "book-appointment": "Rezervasyon randevusu",
        "book-appointment-description": "Düzenli programlayıcı aracılığıyla yeni bir randevu ayarlayın.",
        "staff-assist": "Personeli arayın",
        "staff-assist-description": "Yardıma ihtiyacım var.",
        "booking-disabled": "Appointment booking is currently unavailable",
        "booking-disabled-description": "Please contact the practice team to arrange an appointment.",
        "back-to-start": "Back to start",
        "subtitle-v2": "Bugün sizin için bir randevu bulamadık.",
        "book-v2": "Yeni randevu al",
        "book-v2-description": "Şimdi boş bir saat seçin.",
        "have-appointment": "Randevum var",
        "have-appointment-description": "Resepsiyon size memnuniyetle yardımcı olur.",
        "unavailable-title": "Randevular resepsiyondan alınır",
        "subtitle-unavailable": "Bugün sizin için bir randevu bulamadık. Lütfen resepsiyona başvurun."
      },
      "staff-assist": {
        "title": "Personele bilgi verildi",
        "subtitle": "Bir personel kısa sürede size yardımcı olacaktır.",
        "message": "Lütfen burada bekleyin. Kısa süre içinde bir personel sizinle birlikte olacak.",
        "start-over": "Başa dön",
        "auto-redirect": "{{seconds}} saniye içinde başlangıca dönülüyor..."
      },
      "eeb-prompt": {
        "title": "Sigortayı Doğrula",
        "title-failed": "Doğrulama Başarısız",
        "subtitle": "Sigortanızı nasıl doğrulamak istersiniz?",
        "subtitle-failed": "Doğrulama talebinde bulunmak için QR kodunu sigorta uygulamanızla tarayın.",
        "verify-card": "Elektronik olarak doğrula",
        "verify-card-description": "Sigorta sağlayıcınıza bir istek gönderin.",
        "select-insurer": "Sigortacı seçin",
        "select-insurer-description": "Sigortacınızın manuel seçimi.",
        "skip": "Atla",
        "eyebrow-chip": "Alternatif",
        "eyebrow": "Giriş · sigorta kanıtı (eEB)",
        "recommended": "Önerilen",
        "qr-title": "Sigorta uygulamanızla tarayın",
        "qr-description": "Sağlık sigortası uygulamanızı açın ve kodu tarayın; eEB doğrudan bize gönderilir.",
        "qr-address-label": "Gönder",
        "title-app": "Uygulama ile belge",
        "subtitle-app": "Sigortanız belgeyi doğrudan da bize gönderebilir. Bitirdiğinizde „İleri\"ye dokunun."
      },
      "quarterly-check": {
        "title": "Sigorta Doğrulaması",
        "checking": "Mevcut sigorta doğrulamanızı kontrol ediyoruz...",
        "error": "Kontrol gerçekleştirilemedi.",
        "title-v2": "Sigortanız",
        "checking-v2": "Sigortanızı kontrol ediyoruz – bir dakika lütfen.",
        "error-body": "Kaydınız tamamlandı. Sigortanızı resepsiyon sizinle birlikte netleştirecek."
      },
      "insurer-prefilled": {
        "title": "Sağlık Sigortanız",
        "subtitle": "Lütfen bu çeyrek için sigortanızı onaylayın.",
        "your-insurance": "Sigortanız",
        "last-read": "Son doğrulama tarihi {{date}}",
        "quarterly-notice": "Faturalandırma amacıyla, bu çeyrek için güncel sigorta kanıtına ihtiyacımız var.",
        "confirm-button": "Evet, bu benim sigortam",
        "change-button": "Farklı bir sigortam var",
        "contact-title": "Elektronik Kapsam Kanıtı Talebi",
        "contact-description": "Sigortanızı arayın ve aşağıdakiler için elektronik teminat kanıtı isteyin:",
        "contact-patient": "Hasta",
        "contact-kim-address": "Muayenehane KIM adresi",
        "contact-phone": "Phone",
        "question": "Bu sizin sağlık sigortanız mı?",
        "quarterly-notice-v2": "Üç ayda bir sağlık sigortanızdan bir belgeye ihtiyacımız var."
      },
      "insurer-search": {
        "title": "Sağlık Sigortası Seçin",
        "subtitle": "Lütfen yasal sağlık sigortanızı arayın ve seçin.",
        "placeholder": "Sigorta ara...",
        "hint": "Aramak için en az 2 karakter girin.",
        "no-results": "Sigorta bulunamadı.",
        "no-results-hint": "Yazımı kontrol edin veya farklı bir arama deneyin.",
        "label": "Sağlık sigortanızın adı",
        "search-error-v2": "Arama şu anda olmadı. Lütfen tekrar deneyin.",
        "app-alternative": "Sigortanızın uygulamasıyla mı tercih edersiniz?"
      },
      "insurer-contact": {
        "title": "Sigorta Kanıtı Talebi",
        "subtitle": "Lütfen aşağıdaki seçeneklerden birini seçin.",
        "or": "veya",
        "option-eeb-title": "Elektronik olarak talep edin",
        "option-eeb-description": "Yasal istisna durumu varsa, onayınızın ardından talebi muayenehane ekibine iletebilirsiniz.",
        "option-qr-title": "Uygulamayla tara",
        "option-qr-description": "Sigorta uygulamanızla QR code'i tarayın.",
        "option-call-title": "Kendinizi arayın",
        "option-call-description": "Sigortanızı arayın ve bu muayenehane için bir eEB talep edin:",
        "phone": "Phone",
        "phone-not-available": "Sigorta kartınızdaki telefon numarası",
        "patient-name": "Hasta",
        "practice-kim": "Muayenehane KIM adresi",
        "help-notice": "Herhangi bir sorunla karşılaşırsanız lütfen resepsiyona uğrayın.",
        "submit-eeb-button": "Şimdi talep et",
        "contacted-button": "aradım",
        "contacted-button-countdown": "Aramanızın zamanı ({{seconds}}s)",
        "go-to-counter-button": "Resepsiyona git",
        "qr-continue-button": "Taradım",
        "qr-continue-button-countdown": "Tarama süresi ({{seconds}}s)",
        "title-v2": "Sağlık sigortanızdan belge",
        "subtitle-v2": "En kolayı sigortanızın uygulamasıyladır.",
        "subtitle-no-app": "Sigortanızın belgeyi bize nasıl göndereceğini seçin.",
        "option-eeb-description-v2": "Sigortanıza sizin yerinize biz soruyoruz. Bunun için onayınıza ihtiyacımız var.",
        "call-instruction": "Sigortanızı arayın ve belgeyi muayenehanemize göndermelerini isteyin.",
        "call-instruction-practice": "Sigortanızı arayın ve belgeyi {{practice}} muayenehanesine göndermelerini isteyin.",
        "done-button": "Tamam – ileri",
        "done-button-countdown": "Tamam – ileri ({{seconds}} sn kaldı)"
      },
      "eeb-consent": {
        "title": "Onay",
        "subtitle": "Elektronik sigorta doğrulaması için onayınıza ihtiyacımız var.",
        "insurance": "Sigortanız",
        "consent-title": "Elektronik Sigorta Doğrulaması (eEB) için Onay",
        "consent-text": "Sağlık sigortamın sigorta verilerimi (örn. ad, doğum tarihi, sigorta numarası) sigorta kanıtı olarak güvenli KIM iletişim hizmeti üzerinden {{practiceName}} muayenehanesine ileteceğini anlıyorum. Bu iletime onay veriyorum. Bu onayı tedavimi etkilemeden istediğim zaman geri çekebileceğimi biliyorum.",
        "withdrawal-notice": "Bu onayı istediğiniz zaman geri çekebilirsiniz.",
        "agree-button": "Kabul ediyorum",
        "decline-button": "İptal",
        "treatment-notice": "Tedaviniz bu onaydan etkilenmez.",
        "load-failed": "The consent details could not be loaded. You can scan the QR code with your insurer app instead.",
        "not-available": "This request is not possible here right now. Please speak to reception.",
        "submit-failed": "Your consent could not be saved. Please try again or speak to reception.",
        "title-v2": "Sağlık sigortanızdan belge",
        "summary": "Sigortanız belgeyi doğrudan bize gönderir. Bunun için onayınıza ihtiyacımız var.",
        "confirm-first": "Lütfen önce beyanı onaylayın."
      },
      "qr-code": {
        "title": "Sigorta uygulamasıyla tarayın",
        "instruction-1": "Sigorta uygulamanızı açın ve bu QR kodunu tarayın.",
        "instruction-2": "Muayenehane daha sonra sigorta doğrulamanızı otomatik olarak alır.",
        "practice": "Muayenehane: {{name}}",
        "alternative-hint": "Alternatif: Sigorta uygulamanızı kullanın",
        "instruction-app": "Sağlık sigortanızın uygulamasını açın ve bu kodu okutun. Belge doğrudan bize gelir.",
        "staff-line": "Muayenehane ekibi için: {{address}}",
        "staff-line-practice": "Muayenehane ekibi için: {{name}} · {{address}}",
        "alternative-app": "Belgeyi sigortanızın uygulamasıyla da isteyebilirsiniz: uygulamayı açın ve bu kodu okutun."
      },
      "register-basics": {
        "title": "Kişisel Bilgiler",
        "subtitle": "Lütfen bilgilerinizi girin.",
        "family-name": "Soyad",
        "given-name": "Ad",
        "dob": "Doğum tarihi",
        "gender": "Cinsiyet",
        "insurance-type": "Sigorta türü",
        "insurer-name": "Sigortanızın adı",
        "insurer-name-placeholder": "ör. Debeka, DKV, Allianz...",
        "gender-required": "Lütfen bir seçenek seçin."
      },
      "register-insurer": {
        "title": "Sağlık Sigortası",
        "subtitle": "Lütfen sağlık sigortanızı seçin.",
        "search-placeholder": "Sigorta ara..."
      },
      "register-details": {
        "title": "Özet",
        "subtitle": "Lütfen bilgilerinizi gözden geçirin.",
        "create": "Kaydı tamamla",
        "missing-data": "Lütfen gerekli tüm alanları doldurun.",
        "create-error": "Kayıt başarısız oldu. Lütfen tekrar deneyin.",
        "policy-number": "Poliçe numarası (isteğe bağlı)",
        "policy-number-placeholder": "Poliçe numaranız",
        "create-v2": "Kaydı tamamla",
        "policy-number-hint": "Numarayı sigorta kartınızda bulabilirsiniz."
      },
      "diff-review": {
        "eyebrow-chip": "İnceleme",
        "eyebrow": "Check-in · kart verileri",
        "title": "Veri Karşılaştırması",
        "subtitle": "Kart verileriniz ile kayıtlarımız arasında farklılıklar bulundu.",
        "col-current": "Güncel kayıt",
        "col-new": "Karttan yeni",
        "new-badge": "yeni",
        "field-fallback": "Alanı",
        "note": "Güncellenen veriler, doğru şekilde faturalandırmamıza ve acil durumlarda size ulaşmamıza yardımcı olur.",
        "comparison-placeholder": "Karşılaştırma burada gösterilecek",
        "confirm": "Değişiklikleri onayla",
        "apply-error": "Veriler uygulanamadı. Lütfen tekrar deneyin.",
        "retry": "Tekrar deneyin",
        "skip": "Yine de devam et",
        "no-changes": "Değişiklik bulunamadı",
        "title-v2": "Bilgileriniz değişti",
        "subtitle-v2": "Kartınızda daha yeni bilgiler var. Bunları alalım mı?",
        "confirm-v2": "Al ve kayıt ol",
        "keep": "Değişiklik yapmadan kayıt ol",
        "col-current-v2": "Önceki",
        "col-new-v2": "Karttan yeni",
        "value-yes": "Evet",
        "value-no": "Hayır"
      },
      "insurance-selection": {
        "title": "Sigorta Türü",
        "subtitle": "Lütfen sigorta türünüzü seçin.",
        "gkv": "Yasal sigortalı",
        "gkv-description": "Yasal sağlık sigortası üyesi.",
        "pkv": "Özel veya özel ödeme",
        "pkv-description": "Özel sigortalı veya özel ödeme.",
        "pkv-description-v2": "Özel sağlık sigortası veya kendiniz ödersiniz."
      },
      "eeb-request": {
        "title": "Talep kaydedildi",
        "subtitle": "Kaydınızı tamamlayabilirsiniz. {{insurer}} yanıtı muayenehaneye daha sonra ulaşacaktır.",
        "verifying": "Talebiniz hemen işleme alınmak üzere kabul edildi.",
        "success": "Talebiniz güvenli bir şekilde muayenehane ekibine iletildi.",
        "error": "Talep onayı şu anda kullanılamıyor.",
        "try-alternative": "Alternatif yöntem",
        "kim-load-error": "Muayenehane KIM adresi yüklenemedi.",
        "kim-label": "Muayenehane · KIM",
        "non-blocking-note": "Bu, sağlık sigortanıza ulaştığını veya sigorta durumunuzu henüz onaylamaz.",
        "auto-continue": "{{seconds}} saniye sonra otomatik olarak devam edilecek.",
        "unavailable-title": "Maalesef olmadı",
        "unavailable-v2": "Sağlık sigortasına talebiniz kaydedilemedi.",
        "unavailable-body": "Belgeyi sigortanızın uygulamasıyla gönderebilir veya resepsiyonda halledebilirsiniz.",
        "use-app": "Uygulama ile",
        "at-reception": "Resepsiyonda hallet"
      },
      "self-pay": {
        "title": "Özel Ödeme",
        "subtitle": "Özel ödeme hastası olarak tedavi edileceksiniz.",
        "info": "Lütfen tedavi masraflarından sorumlu olacağınızı unutmayın.",
        "confirm": "Anladım",
        "title-v2": "Kendiniz ödersiniz",
        "subtitle-v2": "Tedaviyi kendiniz ödersiniz.",
        "insured-after-all": "Yine de sigortalıyım"
      },
      "done": {
        "title": "Tamamlandı!",
        "subtitle": "Kaydınız tamamlandı.",
        "finish": "Bitir",
        "done-label": "Yapıldı",
        "error-label": "Bildirim",
        "eyebrow": "Giriş · tamamlandı",
        "queue-label": "Bekleme odası",
        "queue-title": "Lütfen oturun",
        "queue-meta": "Sizi bizzat arayacağız.",
        "success-title": "Kayıt başarılı!",
        "success-subtitle": "Lütfen bekleme odasında oturun. Çağrılacaksınız.",
        "auto-redirect": "Kısa süre içinde başlangıç sayfasına yönlendirileceksiniz...",
        "auto-redirect-countdown": "{{seconds}} saniye içinde başlangıca dönülüyor...",
        "card-expired-title": "Kart süresi dolmuş",
        "card-expired-subtitle": "Sigorta kartınızın süresi dolmuş.",
        "card-expired-info": "Lütfen yardım için personelle iletişime geçin.",
        "back-to-start": "Başlangıca dön",
        "anamnesis-title": "Tıbbi geçmiş formunu doldurun",
        "anamnesis-description": "Tıbbi geçmiş formunuzu akıllı telefonunuzda kolayca doldurmak için QR code'i tarayın.",
        "title-confirm": "Thank you!",
        "subtitle-confirm": "You have confirmed your details. Your check-in is complete — please take a seat in the waiting room.",
        "title-saved": "Thank you!",
        "subtitle-saved": "Your changes have been processed. Reception will get in touch if anything is open. Please take a seat in the waiting room.",
        "title-skip": "Skipped",
        "subtitle-skip": "No problem — your check-in is complete. You can tell reception about changes at any time.",
        "title-v2": "Kaydınız yapıldı",
        "card-expired-info-v2": "Lütfen resepsiyona başvurun."
      },
      "patient-info": {
        "loading": "Loading your contact details …",
        "review": {
          "title": "Review contact details",
          "intro": "Are these details still correct? The review is voluntary — your check-in is already complete.",
          "no-contacts": "No telephone numbers or email addresses are on file.",
          "all-correct": "Everything is correct",
          "skip": "Skip",
          "primary": "Primary",
          "protected": "Reception will review any change to this contact.",
          "reveal": "Show",
          "hide": "Hide",
          "type": {
            "MOBILEPRIV": "Mobile (private)",
            "PHONEPRIV": "Phone (private)",
            "MOBILEJOB": "Mobile (work)",
            "PHONEJOB": "Phone (work)",
            "EMAILPRIV": "Email (private)",
            "EMAILJOB": "Email (work)"
          },
          "save": "Save",
          "save-failed": "Could not save — please speak to reception.",
          "delete": "Delete",
          "undo": "Undo",
          "invalid": "Please check the format.",
          "add": "Add",
          "add-title": "Add a contact",
          "add-type": "Type",
          "add-value": "Enter a value",
          "hausarzt": "Family doctor / GP",
          "hausarzt-placeholder": "Enter a name or practice",
          "hausarzt-reception": "Reception will review any change to this information.",
          "hausarzt-invalid": "Enter no more than 120 characters.",
          "category": {
            "phone": "Phone",
            "email": "Email",
            "hausarzt": "Family doctor"
          },
          "category-empty": "Not on file",
          "primary-tag": "Main contact",
          "protected-chip": "Protected — reception reviews",
          "chip-direct": "Changes: saved directly",
          "chip-reception": "Changes: reception reviews",
          "chip-staged_one": "{{count}} change pending",
          "chip-staged_other": "{{count}} changes pending",
          "chip-will-add": "Will be added",
          "expand-phone_one": "Show {{count}} more number",
          "expand-phone_other": "Show {{count}} more numbers",
          "expand-email_one": "Show {{count}} more address",
          "expand-email_other": "Show {{count}} more addresses",
          "collapse-phone_one": "Hide additional number",
          "collapse-phone_other": "Hide additional numbers",
          "collapse-email_one": "Hide additional address",
          "collapse-email_other": "Hide additional addresses",
          "change": "Change",
          "close": "Close",
          "staged-removal": "Will be removed — value hidden",
          "stage-add": "Add to list",
          "add-more-phone": "Add another number",
          "add-more-email": "Add another address",
          "invalid-phone": "Please enter a valid phone number.",
          "invalid-email": "Please enter a valid email address.",
          "hausarzt-previous": "previously: {{value}}",
          "hausarzt-counter": "{{count}} / 120",
          "balance-total_one": "{{count}} change",
          "balance-total_other": "{{count}} changes",
          "balance-direct": "{{count}} saved directly",
          "balance-reception": "{{count}} reviewed by reception",
          "proposal-open": "Suggest a new address",
          "proposal-placeholder": "Your suggestion",
          "proposal-discard": "Discard",
          "proposal-hint": "Your suggestion goes to reception — the address is not changed immediately.",
          "title-v2": "Bilgilerinizi kontrol edin",
          "balance-prefix": "Kaydederken:",
          "balance-direct-v2": "Hemen kaydedildi: {{count}}",
          "balance-reception-v2": "Resepsiyon kontrol eder: {{count}}",
          "chip-reception-v2": "Değişiklikleri resepsiyonumuz kontrol eder",
          "chip-changed": "Değişti: {{count}}",
          "remove": "Kaldır",
          "example-email": "örn. ad@ornek.com",
          "example-phone": "örn. 0532 123 45 67",
          "intro-v2": "Kaydınız tamamlandı. Bu bilgiler hâlâ doğru mu? Kontrol isteğe bağlıdır.",
          "auto-hide": "Gösterilen değerler kısa süre sonra yeniden gizlenir."
        },
        "result": {
          "title": "Result",
          "continue": "Continue",
          "outcome": {
            "updated": "Updated",
            "satisfied": "Was already up to date",
            "task-created": "Sent to reception",
            "not-saved": "Not saved yet",
            "pending-retry": "Not saved yet"
          },
          "retry": "Try again",
          "removed": "Was removed",
          "cleared": "Was cleared",
          "task-note": "Nothing was overwritten — reception will get in touch if needed.",
          "not-saved-note": "Nothing was overwritten. Please speak to reception.",
          "banner-unfinished": "One detail has not been saved yet. You can try again directly on that row.",
          "banner-done": "Your details have been processed.",
          "footer": "All other details remain unchanged.",
          "task-note-v2": "Bu bilgiyi resepsiyona ilettik.",
          "banner-done-v2": "Teşekkürler! Bilgilerinizi aldık.",
          "footer-v2": "Diğer tüm bilgiler olduğu gibi kalır."
        },
        "expiry": {
          "notice": "For data protection reasons the review ends in 2 minutes. Your check-in stays complete.",
          "title": "The review has expired",
          "body": "For data protection reasons all displayed and entered values were deleted. Your check-in is still complete — you do not need to repeat anything. You can tell reception about changes at any time.",
          "continue": "To the summary",
          "body-v2": "Veri koruması nedeniyle görüntüyü kapattık. Kaydınız yine de tamamlandı. Değişiklikleri istediğiniz zaman resepsiyona bildirebilirsiniz."
        }
      },
      "progress": {
        "identify": "Kayıt",
        "insurance": "Sigorta",
        "done": "Tamam"
      },
      "dob-format-hint": "Örneğin 01.10.1980",
      "dob-required": "Lütfen doğum tarihinizi girin.",
      "insurance-label": {
        "GKV": "Yasal sigortalı",
        "PKV": "Özel sigortalı",
        "SELFPAY": "Kendi ödeyen"
      }
    },
    "emergency": {
      "title": "Akut Acil Durum!",
      "label": "Acil Durum",
      "subtitle": "Bu uyarı yalnızca yerel olarak duyulur ve yardım çağırmamıştır. Akut veya hayati tehlike oluşturabilecek acil durumlarda 112’yi arayın.",
      "call-emergency": "Acil Durum Hizmetlerini Arayın (112)",
      "stop-sound": "Durdurma sesi",
      "play-sound": "Sesi çal",
      "back-to-start": "Başa dön",
      "headline": "Lütfen hemen resepsiyondaki personelle konuşun. Hayati tehlike varsa 112'yi arayın."
    },
    "help-reception": "Resepsiyon yardımı",
    "help-reception-toast": "Lütfen resepsiyona başvurun. Size yardımcı olmaktan mutluluk duyarız.",
    "language-entry": {
      "title": "Dilinizi seçin"
    },
    "loading": "Yükleniyor…",
    "step-progress-label": "İlerleme",
    "step-progress-phase": "Bölüm {{current}}/{{total}}: {{phase}}",
    "step-progress-substep": "Kısım {{current}}/{{total}}",
    "step-progress-complete": "Tamamlandı",
    "identification": {
      "title": "Siz kimsiniz?",
      "lead": "En hızlısı sağlık sigortası kartınızla. Adınızla da arayabilirsiniz.",
      "lead-card-only": "Lütfen sağlık sigortası kartınızı kart okuyucuya takın.",
      "mode-label": "Nasıl giriş yapmak istersiniz?",
      "mode-card": "Kartla",
      "mode-search": "Adla ara",
      "mode-create": "Muayenehanede yeniyim",
      "card": {
        "loading": "Kart okuyucu hazırlanıyor …",
        "checking": "Kart okuyucu kontrol ediliyor …",
        "insert-title": "Lütfen sağlık sigortası kartınızı kart okuyucuya takın.",
        "insert-detail": "Bilgilerinizi otomatik olarak okuyoruz.",
        "detected": "Kart algılandı",
        "read": "Kartı oku",
        "reading": "Kart okunuyor …",
        "reading-hint": "Lütfen kartı takılı bırakın.",
        "no-terminal-title": "Kart okuyucu kullanılamıyor",
        "help-with-search": "Lütfen adınızla arayın veya resepsiyona sorun.",
        "help-reception": "Lütfen resepsiyona sorun – memnuniyetle yardımcı oluruz.",
        "unreadable-title": "Kart algılandı ama okunamıyor",
        "error-title": "Kart okunamadı",
        "not-unique": "Sizi bu kartla net olarak eşleştiremedik. Lütfen adınızla arayın veya resepsiyona sorun.",
        "no-match": "Bu kart için eşleşen bilgi bulamadık. Lütfen adınızla arayın veya resepsiyona sorun.",
        "without-card": "Kartsız devam et"
      },
      "lookup": {
        "lead": "Lütfen soyadınızı ve doğum tarihinizi girin.",
        "first-name": "Ad",
        "last-name": "Soyad",
        "dob": "Doğum tarihi",
        "dob-hint": "Biçim: GG.AA.YYYY",
        "search": "Ara",
        "confirm": "Evet, benim",
        "found-title": "Sizi bulduk",
        "found-body": "Lütfen bunun siz olduğunuzu onaylayın.",
        "first-name-needed-title": "Lütfen adınızı ekleyin",
        "first-name-needed-body": "Sizi net olarak bulabilmemiz için. Ardından „Ara”ya dokunun.",
        "ambiguous-title": "Sizi net olarak bulamadık",
        "ambiguous-body": "Lütfen resepsiyona sorun – memnuniyetle yardımcı oluruz.",
        "not-found-title": "Eşleşen bilgi bulunamadı",
        "not-found-body": "Lütfen girdiğiniz bilgileri kontrol edin.",
        "error-title": "Arama şu anda mümkün değil",
        "error-body": "Lütfen tekrar deneyin veya resepsiyona sorun."
      },
      "create": {
        "insurance-question": "Nasıl sigortalısınız?",
        "insurance-required": "Lütfen nasıl sigortalı olduğunuzu seçin.",
        "error-title": "Bilgileriniz kaydedilemedi",
        "error-body": "Lütfen tekrar deneyin veya resepsiyona sorun."
      }
    }
  },
  "onboarding": {
    "prepare": {
      "title": "Önce kilidi aç",
      "subtitle": "Uygulama yazılımınızda FrontDesk+ etkinleştirilmelidir.",
      "step1": "SolStore'da sipariş verin (veya Doc-Cirrus iş ortağınız sizin için sipariş versin).",
      "step2": "Etkinleştirmeden sonra inSuite'da “inSuite Sols” (yönetici hakları) altında etkinleştirin.",
      "step3": "Bridge yönetimini açın → “Cihaz ekle”.",
      "cta": "Her şey bitti - devam edin"
    },
    "welcome": {
      "title": "Bu cihazı uygulamaya ekleyin",
      "scan": "Kodun fotoğrafını çekin",
      "prepare-link": "inSuite'da kod yok mu?",
      "language": "Dil"
    },
    "scan": {
      "requesting": "Kamera erişimi isteniyor…",
      "scanning": "Kamerayı koda doğrultun",
      "paste": "Bunun yerine yapıştır",
      "manual-title": "Manuel olarak bağlanın",
      "manual-description": "QR kodu mevcut değilse bağlantı verilerini Bridge yönetiminden alın.",
      "address-label": "Bridge adresi",
      "address-placeholder": "https://…/_dinlenme_",
      "soltoken-label": "SOLTOKEN",
      "soltoken-placeholder": "SOLTOKEN'yu ekleyin",
      "manual-submit": "Bağlantıyı devral",
      "error-title": "Kod tanınmadı",
      "camera-denied-title": "Kamera erişimi reddedildi",
      "camera-denied-hint": "Lütfen ayarlarda kamera erişimine izin verin ve tekrar deneyin.",
      "retry": "Tekrar deneyin"
    },
    "preflight": {
      "title": "Kurulacak",
      "all-green": "Tüm testler geçti",
      "practice": "Pratik",
      "device-name": "Cihaz adı",
      "device-name-placeholder": "örneğin B. Resepsiyon 1",
      "card-reader": "Kart okuyucu",
      "pin": "Yeni gizli numara",
      "pin-placeholder": "Dört haneli PIN",
      "finish": "Sona ermek",
      "recheck": "Tekrar kontrol edin",
      "diagnosis": "Tanı Kimliği",
      "checklist-error": "Bridge bağlantıyı reddetti veya erişilemiyor. SOLTOKEN'i ve Bridge adresini kontrol edin.",
      "checklist-retry": "Yeniden kontrol et",
      "edit-token": "SOLTOKEN'i değiştir",
      "rescan": "Kodu yeniden tarayın"
    },
    "persisting": "Kurulum kaydediliyor …",
    "success": {
      "title": "Cihaz eklendi",
      "detail": "Cihaz kısa süre önce pratik bilgisayarında göründü.",
      "starting": "Hasta modu başlıyor…"
    },
    "checklist": {
      "general_api_unavailable": {
        "label": "Uygulama yazılımına bağlantı",
        "fix": "Bridge Bağlantıyı ve sunucu adresini kontrol edin."
      },
      "missing_insuite_url": {
        "label": "inSuite adresi",
        "fix": "QR kodunu tekrar tarayın; adres eksik."
      },
      "missing_server_token": {
        "label": "Sunucu jetonu",
        "fix": "QR kodunu tekrar tarayın; jeton eksik."
      },
      "missing_gateway_session": {
        "label": "Gateway oturumu",
        "fix": "Tekrar oturum açın; oturum eksik."
      },
      "missing_gateway_enrollment": {
        "label": "Cihaz kaydı",
        "fix": "Cihazı Gateway'ya kaydedin."
      },
      "gateway_not_ready": {
        "label": "Gateway hazırlığı",
        "fix": "Gateway'nun kurulumu tamamlamasını bekleyin."
      },
      "token_verification_failed": {
        "label": "Jeton kontrolü",
        "fix": "Sunucu belirtecini veya Bridge bağlantısını kontrol edin."
      },
      "session_expired": {
        "label": "toplantı",
        "fix": "Oturumun süresi doldu; tekrar oturum açın."
      },
      "device_revoked": {
        "label": "Cihaz durumu",
        "fix": "Bu cihaz engellendi. Uygulamaya başvurun."
      },
      "missing_practice_name": {
        "label": "Uygulama adı",
        "fix": "Tıbbi muayenehane adı yüklenemedi (inSuite)."
      },
      "missing_device_name": {
        "label": "Cihaz adı",
        "fix": "Lütfen bir cihaz adı girin."
      },
      "telematik_unavailable": {
        "label": "Telematik altyapısı",
        "fix": "İsteğe bağlı — TI mevcut olur olmaz kart kontrolü mümkün olmaya devam eder."
      },
      "selected_card_reader_unavailable": {
        "label": "Kart okuyucu",
        "fix": "İsteğe bağlı — bir kart okuyucu seçin veya bağlayın."
      },
      "medical_card_unavailable": {
        "label": "SMC-B / HBA",
        "fix": "İsteğe bağlı — tıbbi uygulama kimlik kartını takın (SMC-B)."
      }
    },
    "token": {
      "title": "SOLTOKEN girin",
      "description": "Güvenlik nedeniyle QR kodu SOLTOKEN içermez. Bunu inSuite'te „Sol-Aktivierung“ (FrontDesk+) altında kopyalayın ve buraya yapıştırın.",
      "submit": "Devam",
      "rescan": "Kodu yeniden tarayın"
    }
  }
}
